const cuisineTypeOptions = [
  {
    label: 'Asian',
    value: 0,
  },
  {
    label: 'Deli',
    value: 6,
  },
  {
    label: 'Fast Food',
    value: 8,
  },
  {
    label: 'American Grill',
    value: 10,
  },
  {
    label: 'Italian',
    value: 13,
  },
  {
    label: 'Mediterranean',
    value: 14,
  },
  {
    label: 'Mexican',
    value: 15,
  },
  {
    label: 'Pizza',
    value: 16,
  },
  {
    label: 'Salads',
    value: 18,
  },
]

export default cuisineTypeOptions
